import { UserEmail, Userprofile } from "src/app/_models/Userprofile";

export interface EditAdministratorState {
  admin: Userprofile;
  loading: boolean;
  error: any | null;
  update: boolean;
  emailList: UserEmail[];
}

export const initialEditAdministratorState: EditAdministratorState = {
  admin: null,
  loading: false,
  error: null,
  update: false,
  emailList: [],
};
